/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Plugins.MeevoMessengerSettings {
    'use strict';

    import IMeevoMessengerAutoReply = Meevo.Model.IMeevoMessengerAutoReply;
    import IMeevoMessengerQuickAnswer = Meevo.Model.IMeevoMessengerQuickAnswer;

    class MessageAccordionContoller {
        static $inject = [];  
        public messagesList;
        private preparedMessagesList;

        constructor() { }

        $onChanges() {
            if (!this.messagesList) return;

            this.preparedMessagesList = this.messagesList.map((message: IMeevoMessengerAutoReply | IMeevoMessengerQuickAnswer) => {
                return {
                    name: (<IMeevoMessengerAutoReply>message).name || (<IMeevoMessengerQuickAnswer>message).displayName,
                    body: (<IMeevoMessengerAutoReply>message).body || (<IMeevoMessengerQuickAnswer>message).body
                };
            });       
        }
    }

    class MessageAccordionComponent implements angular.IComponentOptions {
        templateUrl = 'app/plugins/meevoMessengerSettings/components/messageAccordion/messageAccordion.template.html';
        controller = MessageAccordionContoller;
        controllerAs = 'msgAuto';
        bindings: any = {
            messagesList: '='
        };
    }

    angular.module('meevo.plugins.meevoMessengerSettings')
        .component('meevoMessengerSettingsMessageAccordion', new MessageAccordionComponent());

}

